import { Article } from 'phosphor-react';
import React, { useState } from 'react'
import { translate } from '../Services/translation';
import { Envelope } from "phosphor-react";
import SizePickerNotifyMe from './SizePicker.NotifyMe';

const BuyButton = ({ isInStock, articleNumber, cssClass, showSizePicker, label, outOfStockLabel, selectedSizeItem, onClick, hideVariantSelect }) => {
    const [notifyMeActive, setNotifyMeActive] = useState(false);
    const [notifyMeError, setNotifyMeError] = useState();

    const hideVariantSelectByPropOrClass = hideVariantSelect || document.body.classList.contains('product-page--without-variants');

    return <>
    {hideVariantSelectByPropOrClass ?
        <>
            {isInStock && <a className={cssClass} onClick={onClick}>
                <span className="hide-on-reactive-styling">
                    {label}
                </span>
            </a>}
            {!isInStock && <>
                <div className="variant-out-of-stock">
                    <span style={{display: notifyMeActive ? 'none' : 'inline-block'}} className="variant-out-of-stock__text">{translate("size-picker.out-of-stock")}</span>
                    <span className="message-me" style={{display: notifyMeActive ? 'none' : 'flex'}} onClick={setNotifyMeActive}>{translate("size-picker.notify-me")} <Envelope size="20" /></span>
                    <SizePickerNotifyMe visible={notifyMeActive}
                                        className="notify-me-onesize"
                                        showError={false}
                                        onError={err => setNotifyMeError(err)}
                                        articleNumber={articleNumber} />
                </div>
                {notifyMeError && <div className="field-wrapper">
                    <div className="input-error">{notifyMeError}</div>
                </div>}
                <a href="#" className="variant-out-of-stock__privacy-policy">Privacy policy</a>
            </>}
        </>
        : <div className="buy-button-wrapper">
            <div className="fake-select" onClick={() => showSizePicker(false)} >
                <div className="fake-select__content">
                    {selectedSizeItem 
                        ? selectedSizeItem.size
                        : translate("size-picker.placeholder")
                    }
                </div>
                <i className='ph-caret-down fake-select__icon'></i>
            </div>
            <a className={cssClass} onClick={() => selectedSizeItem ? onClick() : showSizePicker(true)}>
                <span className="hide-on-reactive-styling">
                    {!isInStock && outOfStockLabel ? outOfStockLabel : label}
                </span>
            </a>
        </div>
        }
    </>
}

export default BuyButton;